import React from "react";
import {
    // InputNumber,
    Button,
    Row,
    Modal,
    Col,
    Input,
    // message,
    Checkbox,
    // eslint-disable-next-line no-unused-vars
    Select
} from "antd";
import PropTypes from "prop-types";
import { 
    CASE_VIEW_ACTION 
} from "constants";
import DecisionDashboardService from "../modules/decision-dashboard/services";

const radioStyle = {
    display: "block",
    width: "400px",
    height: "30px",
    lineHeight: "30px",
};

class SanctionConditionModal extends React.Component{
    state = {
        visible: false,
        sanctionText: null,
        sanctionConditions: [],
        showSanctionConditions: false,
        selectedCondition: null
    }
    sanctionConditions = [];

    componentDidMount() {
        if (
            this.props.action &&
            this.props.action !== CASE_VIEW_ACTION &&
            (this.props.caseId || this.props.caseIds)
        ) {
            DecisionDashboardService
                .getSanctionConditions(this.props.caseId).then((res) => {
                    try {
                        let data = res.data && res.data.data;
                        this.sanctionConditions = data;
                        let options = [];
                        if(data) {
                            const variableRegex = /(\{{.*?\}})/g;
                            options = data.map((_, k) => {
                                let fields = _.title.match(variableRegex);
                                this.fieldObj = {
                                    ...this.fieldObj,
                                    [k]: {}
                                };
                                fields = fields.map(_ => _.split("{{")[1].split("}}")[0]);
                                fields.map(__ => {
                                    this.fields = {
                                        ...this.fields,
                                        [k]: {}
                                    };
                                    this.fieldObj = {
                                        ...this.fieldObj,
                                        [k]: {
                                            ...this.fieldObj[k],
                                            [`{{${__}}}`]: {
                                                type: _.keys[__].type,
                                                options: _.keys[__].options,
                                                suffix : _.keys[__].suffix,
                                                title: _.title
                                            }
                                        }
                                    };
                                });
                                let text = _.title;
                                return text;
        
                            });                    
                        }
                        this.setState({
                            sanctionConditions: options,
                        });
                    } catch(err) {
                        console.error(err);
                    }
                });
            this.toggleModal();
        }
        
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.action &&
            nextProps.action !== CASE_VIEW_ACTION &&
            (nextProps.caseId || nextProps.caseIds)
        ) {
            this.toggleModal();
        }
    }

    approveCase = () => {
        const selectedSanctionCondition = this.sanctionConditions[this.state.selectedCondition];
        const selectedConditionValues = this.fields && this.state.selectedCondition && this.fields[this.state.selectedCondition];
        let values={
            ...selectedSanctionCondition && selectedSanctionCondition.keys,
        };
        let selectedValues = values;
        Object.keys(values).map(_ => {
            selectedValues[_].response = selectedConditionValues[`{{${_}}}`] || "1";
        });
        let selectedTitle = selectedSanctionCondition && selectedSanctionCondition.title;
        const variableRegex = /(\{{.*?\}})/g;
        let titleFields = selectedTitle && selectedTitle.match(variableRegex);
        titleFields = titleFields && titleFields.map(_ => _.split("{{")[1].split("}}")[0]);
        titleFields && titleFields.map(_ => {
            let value = selectedValues[_].response;
            if(selectedValues[_].suffix) {
                value = String(value) + selectedValues[_].suffix;
            }
            selectedTitle = selectedTitle.replace(`{{${_}}}`, value);
        });
        let sanction_remarks = this.state.sanctionText;
        if(selectedTitle) {
            sanction_remarks = sanction_remarks + ". " + selectedTitle;
        }
        // let initial_loaded_limit = 0;
        let sanctionArray = [];
        if(selectedValues && selectedValues["ll_as_perc_of_sl"]) {
            sanctionArray = this.props.sanctionArray.map(_ => ({
                ..._,
                initial_loaded_limit: (+_.sanction_limit * +selectedValues["ll_as_perc_of_sl"].response)/100
            }));
            // initial_loaded_limit = (+this.state.sanctionAmount * +selectedValues["ll_as_perc_of_sl"].response)/100;
        } else {
            sanctionArray = this.props.sanctionArray.map(_ => ({
                ..._,
                initial_loaded_limit: +_.sanction_limit
            }));
        }
        this.props.upgradeCase(
            this.props.action,
            null,
            this.props.caseIds,
            {
                "sanction_limit": this.state.sanctionAmount,
                "sanction_remarks": sanction_remarks,
                "sanction_condition": {...selectedValues, title: selectedTitle},
                "sanction": sanctionArray
            }
        );
    };

    onChangeVal = (field, index, val) => {
        this.fields = {...this.fields, [index]: {
            ...this.fields[index],
            [field]: val
        }};
        this.setState({
            date: new Date(),
            selectedCondition: index
        }, () => {
            this.setSanctiontext();
        });
    }

    onChangeInputVal = (field, index, e) => {
        this.fields = {...this.fields, [index]: {
            ...this.fields[index],
            [field]: e.target.value
        }};
    }

    getOption = (text, index) => {
        const field = this.fieldObj[index][text];
        if(field) {
            if(field.type === "SELECT") {
                return (
                    <Select
                        size={"small"}
                        style={{width: "65px"}}
                        onChange={this.onChangeVal.bind(null, text, index)}
                        value={this.fields[index][text]}
                        dropdownMatchSelectWidth={false}
                    >
                        {field.options.map(v => (
                            <Select.Option key={v} value={v}>{`${v}${field.suffix || ""}`}</Select.Option>)
                        )}
                    </Select>
                );
            } else {
                return (
                    <Input size={"small"} style={{width: "50px"}} onChange={this.onChangeInputVal.bind(null, text, index)} />
                );
            }
        }
        // return this.fieldObj[index][text];
    }

    toggleModal = () => {
        this.setState({
            visible: !this.state.visible
        });
    }

    onModalCancel = () => {
        this.setState(
            {
                modalVisible: false,
            },
            () =>
                this.props.resetState()
        );
    };

    onChangeCondition = (e) => {
        if(this.state.selectedCondition === e[e.length - 1]){
            this.setState({
                selectedCondition: null
            });
        } else {
            this.setState({
                selectedCondition: e[e.length - 1],
            }, () => {
                this.setSanctiontext();
            });
        }
    }

    setSanctiontext = () => {
        const selectedSanctionCondition = this.sanctionConditions[this.state.selectedCondition];
        const selectedConditionValues = this.fields[this.state.selectedCondition];
        let values={
            ...selectedSanctionCondition && selectedSanctionCondition.keys,
        };
        let selectedValues = values;
        Object.keys(values).map(_ => {
            selectedValues[_].response = selectedConditionValues[`{{${_}}}`] || "1";
        });
        let selectedTitle = selectedSanctionCondition && selectedSanctionCondition.title;
        const variableRegex = /(\{{.*?\}})/g;
        let titleFields = selectedTitle && selectedTitle.match(variableRegex);
        titleFields = titleFields && titleFields.map(_ => _.split("{{")[1].split("}}")[0]);
        titleFields && titleFields.map(_ => {
            let value = selectedValues[_].response;
            if(selectedValues[_].suffix) {
                value = String(value) + selectedValues[_].suffix;
            }
            selectedTitle = selectedTitle.replace(`{{${_}}}`, value);
        });
        this.setState({
            sanctionText: selectedTitle
        });
    } 

    isSanctionDisabled = () => {
        if(this.state.selectedCondition !== null){
            let title = this.sanctionConditions[this.state.selectedCondition] && 
                this.sanctionConditions[this.state.selectedCondition].title;
            if(!title) {
                return false;
            }    
            const variableRegex = /(\{{.*?\}})/g;
            const check = title.match(variableRegex);
            if(check){
                const nullCheck = check.filter(_ => !this.fields[this.state.selectedCondition][`${_}`]);
                if(nullCheck && nullCheck.length){
                    return true;
                }
                return false;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    toggleSanctionConditions = () => {
        this.setState({
            showSanctionConditions: !this.state.showSanctionConditions
        });
    }

    closeSanctionModal = isTrue => {
        this.setState(
            {
                toggleSanctionModal: false
            },
            () => {
                if (isTrue) {
                    this.approveCase();
                }
            }
        );
    };

    render(){
        return (
            <Modal
                title={"Sanction"}
                visible={this.state.visible}
                closable
                onCancel={this.onModalCancel}
                destroyOnClose={true}
                footer={null}
                maskClosable
            >
                <Input.TextArea
                    className={"mt-5"}
                    placeholder={"Please Enter Sanction Remarks here..."}
                    onChange={val => {
                        this.setState({
                            sanctionText: val.target.value
                        });
                    }}
                    value={this.state.sanctionText}
                    autoSize={{ minRows: 5, maxRows: 5 }}
                />
                {this.state.showSanctionConditions ?
                    (
                        <div className={"mt-10 w-100 d-flex flex-column"}>
                            <span style={{
                                fontWeight: 600
                            }}>{"Select Conditions"}</span>
                            <Checkbox.Group value={[this.state.selectedCondition]} onChange={this.onChangeCondition}>
                                {this.state.sanctionConditions.map((_, k) => {
                                    let row = _;
                                    // eslint-disable-next-line no-unused-vars
                                    let myKeys = [];
                                    const variableRegex = /(\{{.*?\}})/g;
                                    myKeys = row.match(variableRegex);
                                    let values = row.split(" ").map(__ => {
                                        if(myKeys.includes(__)){
                                            return this.getOption(__, k);
                                        }  else {
                                            return __;
                                        } 
                                    });
                                    return(<Row key={k}>
                                        <Col span={2}>
                                            <Checkbox style={radioStyle} key={k} value={k}>
                                            </Checkbox>
                                        </Col>
                                        <Col span={22}>
                                            <p style={{
                                                lineHeight: "30px"
                                            }}>
                                                {values.map((__, key) => (
                                                    <React.Fragment key={key}>{__} {" "}</React.Fragment>
                                                ))}
                                            </p>
                                        </Col>
                                    </Row>);
                                }
                                )}
                            </Checkbox.Group>
                        </div>
                    )
                    : null
                }
                <div className={"mt-10 w-100 d-flex flex-row justify-content-space-between"}>
                    {(!this.state.showSanctionConditions && this.sanctionConditions && this.sanctionConditions.length) ? <Button size={"small"} type={"link"} icon={"plus"} onClick={this.toggleSanctionConditions}>
                        {"Add Conditions"}
                    </Button> : <div>{""}</div>}
                    <div>
                        <Button className={"mr-5"} type={"default"} size={"small"} onClick={this.closeSanctionModal.bind(null, false)}>
                            Cancel
                        </Button>
                        <Button type={"primary"} disabled={this.isSanctionDisabled()} size={"small"} onClick={this.closeSanctionModal.bind(null, true)}>
                            Sanction
                        </Button>
                    </div>
                </div>
            </Modal>
        );
    }
}


SanctionConditionModal.propTypes = {
    location: PropTypes.object,
    history: PropTypes.object,
    action: PropTypes.string,
    upgradeCase: PropTypes.func,
    closeActionModal: PropTypes.func,
    stageName: PropTypes.string,
    caseIds: PropTypes.array,
    stageId: PropTypes.number,
    selectedCasesType: PropTypes.string,
    caseId: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
    caseTaskId: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
    caseTaskIds: PropTypes.array,
    filters: PropTypes.object,
    page: PropTypes.number,
    pageSize: PropTypes.number,
    sanctionArray: PropTypes.array,
    resetState: PropTypes.func
};

export default SanctionConditionModal;